"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoredCodeBlockShowLineNumbers = exports.getStoredCodeBlockWrapColumn = exports.getCodeBlockShowLineNumbers = exports.getCodeBlockWrapColumn = exports.DEFAULT_CODE_BLOCK_SHOW_LINE_NUMBERS = exports.DEFAULT_CODE_BLOCK_WRAP_COLUMN = void 0;
exports.DEFAULT_CODE_BLOCK_WRAP_COLUMN = 80;
exports.DEFAULT_CODE_BLOCK_SHOW_LINE_NUMBERS = true;
const roundPositive = (value, fallback) => {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return fallback;
    return Math.max(0, Math.round(value));
};
const getCodeBlockWrapColumn = (value) => {
    const nextValue = roundPositive(value, exports.DEFAULT_CODE_BLOCK_WRAP_COLUMN);
    return nextValue > 0 ? nextValue : exports.DEFAULT_CODE_BLOCK_WRAP_COLUMN;
};
exports.getCodeBlockWrapColumn = getCodeBlockWrapColumn;
const getCodeBlockShowLineNumbers = (value) => value === undefined ? exports.DEFAULT_CODE_BLOCK_SHOW_LINE_NUMBERS : value;
exports.getCodeBlockShowLineNumbers = getCodeBlockShowLineNumbers;
const getStoredCodeBlockWrapColumn = (value) => {
    const nextValue = (0, exports.getCodeBlockWrapColumn)(value);
    return nextValue === exports.DEFAULT_CODE_BLOCK_WRAP_COLUMN ? undefined : nextValue;
};
exports.getStoredCodeBlockWrapColumn = getStoredCodeBlockWrapColumn;
const getStoredCodeBlockShowLineNumbers = (value) => value === exports.DEFAULT_CODE_BLOCK_SHOW_LINE_NUMBERS ? undefined : value;
exports.getStoredCodeBlockShowLineNumbers = getStoredCodeBlockShowLineNumbers;
